// TSS vite/04 §"Endpoint paths". baseURL ya incluye /api/v1.
// Genealogía (admin-genealogy.md): árbol ancestral recursivo por animal.

export const genealogyPaths = {
    tree: (animalId) => `admin/animals/${animalId}/genealogy`,
};
